var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "250px",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9804764%",
    y1: "8.68053889e-07%",
    x2: "49.9804764%",
    y2: "100.030167%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52D27",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF171D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube-seeklogo.com",
    transform: "translate(10.000000, 44.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#420000",
    opacity: 0.12,
    points: "91.28125 46.0898438 145.816406 82.4765625 153.453125 78.5234375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.575166,34.859375 C227.575166,34.859375 225.329949,19.046875 218.414682,12.0390625 C209.703241,2.875 199.914096,2.875 195.333854,2.3359375 C163.272159,0 115.044904,0 115.044904,0 L114.955096,0 C114.955096,0 66.7278407,0 34.4865287,2.3359375 C29.9960953,2.875 20.2069504,2.875 11.4057009,12.0390625 C4.58024209,19.046875 2.33502538,34.859375 2.33502538,34.859375 C2.33502538,34.859375 0,53.546875 0,72.1445312 L0,89.5742188 C0,108.171875 2.33502538,126.769531 2.33502538,126.769531 C2.33502538,126.769531 4.58024209,142.582031 11.4955096,149.589844 C20.2069504,158.753906 31.70246,158.484375 36.8215541,159.382812 C55.2323311,161.179688 114.955096,161.71875 114.955096,161.71875 C114.955096,161.71875 163.272159,161.628906 195.423662,159.292969 C199.914096,158.753906 209.703241,158.753906 218.50449,149.589844 C225.419758,142.582031 227.664974,126.769531 227.664974,126.769531 C227.664974,126.769531 230,108.171875 230,89.5742188 L230,72.1445312 C229.910191,53.546875 227.575166,34.859375 227.575166,34.859375 L227.575166,34.859375 Z M91.2456072,110.6875 L91.2456072,46.0898438 L153.393206,78.5234375 L91.2456072,110.6875 L91.2456072,110.6875 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.bb8774b381261b075712dca040990a6a.svg";
export { ForwardRef as ReactComponent };